import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  headerCell: {
    padding: theme.spacing(1, 2),
    '&:first-of-type': {
      paddingLeft: theme.spacing(4)
    },
    '&:last-of-type': {
      paddingRight: theme.spacing(4)
    }
  },
  cell: {
    padding: theme.spacing(1, 2),
    '&:first-of-type': {
      paddingLeft: theme.spacing(4)
    },
    '&:last-of-type': {
      paddingRight: theme.spacing(4)
    }
  }
});

export default makeStyles(styles);
